export default __webpack_public_path__ + "static/media/search.6bd14789.svg";